import { RootState } from "redux/rootReducer";

export const selectIsLoadingPatientList = (state: RootState) =>
  state.patientList.loading;
export const selectpatientListErrorMessage = (state: RootState) =>
  state.patientList.error;
export const patientListDataResponse = (state: RootState) =>
  state.patientList.patientListResponse;
